// extracted by mini-css-extract-plugin
export default {"crossImage":"OR2aGZxmbGtA_6Z2bxWj","message":"Th6PleaLroVgWkecwfL2","closeButton":"pg762Mgr6UMA9ZIt0ypF"};